module.exports = __webpack_public_path__ + "img/websiteBg.b5bad196.png";